import { cookie, PLC_TOKEN } from '../cookie';
import { ON_SERVER } from '../context';

const getAuthToken = (): string => {
  const token = cookie.get(PLC_TOKEN);

  if (!token) return;

  // eslint-disable-next-line consistent-return
  return token;
};

const setAuthToken = (token: string): void => {
  cookie.set(PLC_TOKEN, token, { expires: 365 });
};

const cookiesToDestroyOnLogout = [PLC_TOKEN];

const deleteAuthToken = (): void => {
  cookiesToDestroyOnLogout.forEach((cookieKey) => {
    cookie.remove(cookieKey);
  });
};

const isAuthenticated = (): boolean => {
  const token = getAuthToken();

  if (!token) return false;

  return true;
};

const getUserToken = (token?: string): string | null => {
  if (ON_SERVER || token) {
    return token;
  }

  return getAuthToken() || null;
};

export {
  getAuthToken,
  getUserToken,
  setAuthToken,
  isAuthenticated,
  deleteAuthToken,
};
